import React from 'react';
import Layout from './Layout';
import { useRouter } from 'next/router';
import { seoBasicPage } from '../staticData/Seo';
import { BasicPageProps } from './../types/layout/BasicPageTypes';
import { InternalAdsContainer } from '../components/shared/InternalAd';
import { renderStaticContent } from '../helpers/renderStaticContent';

const BasicPage: React.FC<BasicPageProps> = (props: BasicPageProps) => {
  const router = useRouter();

  const dynamicSeo = seoBasicPage.find((seo) => seo.path === router.asPath);

  const headContent = {
    title: props.headTitle || props.heading,
    description: dynamicSeo?.description || (typeof props.content === 'string' ? props.content : ''),
    keywords: [props.headTitle],
    og: { title: props.headTitle }
  };

  return (
    <Layout head={headContent}>
      <div className='basic-page bg-[#252A2D] py-16 px-8 md:px-24 lg:px-36 xl:px-48'>
        <div 
          dangerouslySetInnerHTML={{ __html: renderStaticContent(props.content) }} 
        />
      </div>
      <InternalAdsContainer placement="cms_pages" height="360" />
    </Layout>
  );
};

export default BasicPage;